var _circle, _path, _path2, _path3, _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup502(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FEDC74"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3359 23.8164L23.807 30.111L13.7207 34.7212",
    stroke: "#B4643A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8906 23.8164L35.4196 30.111L45.5059 34.7212",
    stroke: "#B4643A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9837 43.0908C37.9837 45.6081 34.4056 43 29.9918 43C25.5781 43 22 45.6081 22 43.0908",
    stroke: "#B4643A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.5,
    cy: 38,
    rx: 4.5,
    ry: 2,
    fill: "#FF9C8E"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.5,
    cy: 38,
    rx: 4.5,
    ry: 2,
    fill: "#FF9C8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup502);
export default __webpack_public_path__ + "static/media/Group 502.11e66d46f9ac3a13dd2c507e56a645b8.svg";
export { ForwardRef as ReactComponent };